import React from "react";

import { toast } from "react-hot-toast";

import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import InputField from "../../components/inputField/inputField";
import TextEditor from "../../components/textEditor/textEditor";
import withRouter from "../../components/withRouter/withRouter";
import ToggleSwitch from "../../components/toggleSwitch";
import {
  addUpdateApi,
  deleteByIdApi,
  getByIdApi,
  getCategoriesApi,
  uploadImageApi,
} from "../../api";
import CategoryDropDown from "../../components/categoryDropDown/CategoryDropDown";
// import { getFileName } from "../../Utils/getFileName";
// import langObj from "../../Utils/lang";

class AddUpdateIndustries extends React.Component {
  state = {
    imageUrl: "",
    imageObject: "",
    imageCaption: "",
    imageAlt: "",
    content: "", // body
    title: "",
    shortDescription: "", // description
    category: "",
    tags: [],
    tagText: "",
    adOneUrl: "",
    adTwoUrl: "",
    buttonOneUrl: "",
    buttonTwoUrl: "",
    loading: false,
    isImageChanged: false,
    author: "",
    showBtn: false,
    keyPoints: [],
    qanda: [],
    why: [],
    whyHeading: "",
    fold1: { heading: "", description: "" },
    description: "",
    metaCanonicalUrl: "",
    metaTitle: "",
    metaDescription: "",
    slug: "",
    categories: [],
    buttonText: "",
    buttonLink: "",
  };

  componentDidMount() {
    this.getCategories();
    if (this.props.router.params.id) {
      this.setState({ loading: true });
      this.getData();
    }
  }

  getCategories = () => {
    getCategoriesApi()
      .then((res) => {
        console.log(res);
        const d = res.data.filter((val) => val.categoryType === "Industry");

        this.setState({ categories: d });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getData = () => {
    getByIdApi("industry", this.props.router.params.id)
      .then((res) => {
        const temp = res.data;
        console.log(temp);
        this.setState({
          imageUrl: temp?.bannerImage,
          imageCaption: temp?.bannerImageCaption,
          imageAlt: temp?.bannerImageAlt,
          title: temp?.title,
          tags: temp?.tags,
          category: temp?.category,
          subTitle: temp?.subTitle,
          description: temp?.description,
          content: temp?.blogContent,
          metaImageUrl: temp?.metaDescription?.metaImageUrl,
          loading: false,
          buttonText: temp?.buttonText,
          buttonLink: temp?.buttonLink,
          showBtn: temp?.buttonShow,
          fold1: {
            heading: temp?.fold1?.heading,
            description: temp?.fold1?.description,
          },
          whyHeading: temp?.whatSection?.heading,
          why: temp?.whatSection?.items?.map((val) => ({
            icon: { url: val.icon, obj: "" },
            iconCaption: val.iconCaption,
            iconAlt: val.iconAlt,
            title: val.title,
            description: val.description,
          })),
          slug: temp?.metaData?.slug,
          metaTitle: temp?.metaData?.metaTitle,
          metaDescription: temp?.metaData?.metaDescription,
          metaCanonicalUrl: temp?.metaData?.canonicalUrl,
        });
      })
      .catch((err) => {
        toast.error("Something went wrong while getting blog data.");
        this.props.router.navigate("/blogs");
      });
  };

  handleImage = (event) => {
    this.setState({
      imageUrl: URL.createObjectURL(event.target.files[0]),
      imageObject: event.target.files[0],
      isImageChanged: true,
    });
  };

  validate = () => {
    if (!this.state.imageUrl) {
      toast.error("Image Url is required.");
      return false;
    }
    if (!this.state.imageCaption) {
      toast.error("Image Caption is required.");
      return false;
    }
    if (!this.state.imageAlt) {
      toast.error("Image Alt is required.");
      return false;
    }
    if (!this.state.title) {
      toast.error("Title is required.");
      return false;
    }
    if (!this.state.category) {
      toast.error("Category is required.");
      return false;
    }
    if (this.state.tags.length === 0) {
      toast.error("Keywords are required.");
      return false;
    }
    if (this.state.showBtn && !this.state.buttonText) {
      toast.error("Button text is required.");
      return false;
    }
    if (this.state.showBtn && !this.state.buttonLink) {
      toast.error("Button link is required");
      return false;
    }
    if (!this.state.description) {
      toast.error("Description is required.");
      return false;
    }
    if (!this.state.fold1.heading) {
      toast.error("Fold 1 heading is required.");
      return false;
    }
    if (!this.state.fold1.description) {
      toast.error("Fold 1 description is required.");
      return false;
    }
    if (this.state.why.length === 0) {
      toast.error("What section is required.");
      return false;
    }
    if (!this.state.whyHeading) {
      toast.error("What Section heading is required.");
      return false;
    }
    for (let i = 0; i < this.state.why.length; i++) {
      const v = this.state.why[i];

      if (!v.icon.url) {
        toast.error("What section icon is required.");
        return false;
      }
      if (!v.title) {
        toast.error("What section title is required.");
        return false;
      }
      if (!v.description) {
        toast.error("What section description is required.");
        return false;
      }
    }

    if (!this.state.slug) {
      toast.error("Slug is required.");
      return false;
    }
    if (!this.state.metaTitle) {
      toast.error("Meta Title is required.");
      return false;
    }
    if (!this.state.metaDescription) {
      toast.error("Meta Description is required.");
      return false;
    }
    if (!this.state.metaCanonicalUrl) {
      toast.error("Canonical Url is required.");
      return false;
    }
    return true;
  };

  uploadImage = async () => {
    if (this.state.imageObject) {
      try {
        const response = await uploadImageApi(
          this.state.imageObject,
          "industry"
        );

        return response.data.imageUrl;
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
    return this.state.imageUrl;
  };

  getWhatData = async () => {
    const whyData = {
      heading: this.state.whyHeading,
      items: [],
    };

    for (let i = 0; i < this.state.why.length; i++) {
      if (this.state.why[i].icon.obj) {
        const ii = await uploadImageApi(this.state.why[i].icon.obj, "industry");

        whyData.items.push({
          icon: ii.data.imageUrl,
          iconCaption: this.state.why[i]?.iconCaption,
          iconAlt: this.state.why[i]?.iconAlt,
          title: this.state.why[i].title,
          description: this.state.why[i].description,
        });
      } else {
        whyData.items.push({
          icon: this.state.why[i].icon.url,
          iconCaption: this.state.why[i]?.iconCaption,
          iconAlt: this.state.why[i]?.iconAlt,
          title: this.state.why[i].title,
          description: this.state.why[i].description,
        });
      }
    }

    return whyData;
  };

  handleSubmit = (event) => {
    if (event.target.name === "btn3") {
      this.props.router.navigate("/industries");
    } else {
      if (this.validate()) {
        this.setState({ loading: true });
        this.uploadImage()
          .then(async (e) => {
            let data = {
              bannerImage: e,
              bannerImageCaption: this.state.imageCaption,
              bannerImageAlt: this.state.imageAlt,
              title: this.state.title,
              category: this.state.category,
              tags: this.state.tags,
              buttonLink: this.state.buttonLink,
              buttonText: this.state.buttonText,
              buttonShow: this.state.showBtn,
              description: this.state.description,
              fold1: this.state.fold1,
              whatSection: await this.getWhatData(),
              metaData: {
                slug: this.state.slug,
                metaTitle: this.state.metaTitle,
                metaDescription: this.state.metaDescription,
                canonicalUrl: this.state.metaCanonicalUrl,
              },
            };

            addUpdateApi({
              data,
              type: "industry",
              method: this.props.router.params.id ? "patch" : "post",
              id: this.props.router.params?.id,
            })
              .then((response) => {
                toast.success("Added Successfully.");
                this.props.router.navigate("/industries");
              })
              .catch((err) => {
                if (
                  err?.response?.data?.message ===
                  `E11000 duplicate key error collection: admin.industries index: metaData.slug_1 dup key: { metaData.slug: "asdfasdf" }`
                ) {
                  toast.error("Slug already exists please use other value.");
                } else toast.error("Something went wrong.");
                this.setState({ loading: false });
              });
          })
          .catch((error) => {
            console.log(error);
            toast.error("something went wrong");
            this.setState({ loading: false });
          });
      }
    }
  };

  deleteCategory = (id) => {
    this.setState({ loading: true });
    deleteByIdApi("category", id)
      .then(() => {
        toast.success("Category deleted successfully.");
        getCategoriesApi()
          .then((res) => {
            const d = res.data.filter((val) => val.categoryType === "Industry");

            this.setState({ categories: d, loading: false });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        toast.error("Something went wrong while deleting category.");
      });
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title={this.props?.title ? "Update Solutions" : "Add New Industry"}
            showBtn1={true}
            showBtn2={false}
            showBtn3={true}
            btn1type="filled"
            btn2type="outlined"
            btn3type="outlined_del"
            btn1Name="btn1"
            btn2Name="btn2"
            btn3Name="btn3"
            btn1Text={"Save"}
            btn2Text={"Save As Draft"}
            btn3Text={"Cancel"}
            onClickHandler={this.handleSubmit}
          />
          <ContentBody>
            <div className="grid">
              <div className="card grid">
                <h3>Hero</h3>
                <div>
                  <p
                    style={{
                      fontSize: ".9",
                      transform: "translateX(5px)",
                      marginTop: "10px",
                    }}
                  >
                    Banner Image
                    <span
                      style={{ color: "#a3a3a3", fontSize: ".8rem" }}
                    ></span>
                    {this.state.imageUrl && (
                      <span
                        style={{
                          display: "inline-flex",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          color: "#CB1829",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          this.setState({ imageUrl: "", imageObject: "" });
                        }}
                        title="Delete image"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    )}
                  </p>

                  {!this.state.imageUrl ? (
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        background: "transparent",
                        border: "1px dashed grey",
                        borderRadius: "10px",
                        margin: "10px",
                        cursor: "pointer",
                        position: "relative",
                        marginBottom: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="file"
                        style={{
                          opacity: 0,
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0,
                          cursor: "pointer",
                        }}
                        accept="image/*"
                        onChange={this.handleImage}
                      ></input>
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "45%",
                        aspectRatio: "16/9",
                        backgroundImage: `url('${this.state.imageUrl}')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        marginBottom: "40px",
                        marginTop: "10px",
                        borderRadius: "15px",
                        position: "relative",
                      }}
                    ></div>
                  )}

                  {this.state.imageUrl && (
                    <div className="grid_2">
                      <InputField
                        isLabel={true}
                        value={this.state.imageCaption}
                        lable={"Image Caption"}
                        type="text"
                        isRequired={false}
                        placeholder=""
                        onChange={(event) => {
                          this.setState({ imageCaption: event.target.value });
                        }}
                      />
                      <InputField
                        isLabel={true}
                        value={this.state.imageAlt}
                        lable={"Image Alt"}
                        type="text"
                        isRequired={false}
                        placeholder=""
                        onChange={(event) => {
                          this.setState({ imageAlt: event.target.value });
                        }}
                      />
                    </div>
                  )}

                  <InputField
                    isLabel={true}
                    value={this.state.title}
                    lable={"Title"}
                    type="text"
                    isRequired={false}
                    placeholder=""
                    onChange={(event) => {
                      this.setState({ title: event.target.value });
                    }}
                    style={{ marginTop: "5px" }}
                    showCharLength={true}
                    limitChar={40}
                  />
                </div>

                <div className="grid_2">
                  <CategoryDropDown
                    categories={this.state.categories}
                    value={this.state.category}
                    placeholder="Select/Add Category"
                    onChange={(v) => this.setState({ category: v })}
                    deleteCategory={this.deleteCategory}
                  />
                  <div>
                    <InputField
                      type="text"
                      isLabel={true}
                      value={this.state.tagText}
                      lable={"Keywords (Press Enter to add value)"}
                      isRequired={false}
                      placeholder={"Comma separated values"}
                      onChange={(e) => {
                        this.setState({ tagText: e.target.value });
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          this.setState({
                            tags: [...this.state.tags, this.state.tagText],
                            tagText: "",
                          });
                        }
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      {this.state.tags.map((tag, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              background: "var(--blue-light)",
                              color: "var(--blue-dark)",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            {tag}
                            <FontAwesomeIcon
                              icon={faClose}
                              style={{
                                color: "var(--blue-dark)",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                let temp = [...this.state.tags];
                                temp.splice(index, 1);
                                this.setState({ tags: temp });
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    style={{
                      height: "50px",
                      width: "100%",
                      border: "1px solid lightgrey",
                      background: "white",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      paddingInline: "15px",
                      justifyContent: "space-between",
                      marginTop: "25px",
                    }}
                  >
                    <p>Show Button</p>
                    <ToggleSwitch
                      value={this.state.showBtn}
                      onClick={() =>
                        this.setState({ showBtn: !this.state.showBtn })
                      }
                    />
                  </div>
                  {this.state.showBtn && (
                    <>
                      <InputField
                        type="text"
                        isLabel={true}
                        value={this.state.buttonText}
                        lable="Button Text"
                        placeholder="Enter button text"
                        onChange={(e) =>
                          this.setState({ buttonText: e.target.value })
                        }
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        value={this.state.buttonLink}
                        lable="Button Link"
                        placeholder="Enter button Link"
                        onChange={(e) =>
                          this.setState({ buttonLink: e.target.value })
                        }
                      />
                    </>
                  )}
                </div>

                <InputField
                  type="textarea"
                  value={this.state.description}
                  isLabel={true}
                  lable={"Description"}
                  onChange={(e) =>
                    this.setState({ description: e.target.value })
                  }
                />
              </div>

              <div className="card grid">
                <h3>Fold 1</h3>
                <InputField
                  type="text"
                  value={this.state.fold1.heading}
                  lable="Heading"
                  onChange={(e) => {
                    this.setState({
                      fold1: { ...this.state.fold1, heading: e.target.value },
                    });
                  }}
                  isLabel={true}
                />
                <InputField
                  type="textarea"
                  isLabel={true}
                  lable="Description"
                  value={this.state.fold1?.description}
                  onChange={(e) => {
                    this.setState({
                      fold1: {
                        ...this.state.fold1,
                        description: e.target.value,
                      },
                    });
                  }}
                />
              </div>

              <div className="card grid">
                <h3>
                  What Section
                  <button
                    onClick={() => {
                      let temp = [...this.state.why];
                      temp.push({
                        title: "",
                        description: "",
                        icon: "",
                      });
                      this.setState({ why: temp });
                    }}
                  >
                    Add
                  </button>
                </h3>
                {this.state.why.length !== 0 && (
                  <div className="grid">
                    <InputField
                      type="text"
                      value={this.state.whyHeading}
                      lable="Heading"
                      onChange={(e) =>
                        this.setState({ whyHeading: e.target.value })
                      }
                      isLabel={true}
                    />
                    {this.state.why.map((value, index) => {
                      return (
                        <div className="sub_card grid" key={index}>
                          <FontAwesomeIcon
                            icon={faClose}
                            className="sub_card_close"
                            onClick={() => {
                              let temp = this.state.why;
                              temp.splice(index, 1);
                              this.setState({ why: [...temp] });
                            }}
                          />
                          <div>
                            <p style={{ fontSize: ".9rem" }}>Icon</p>
                            {value.icon.url ? (
                              <div
                                style={{
                                  width: "70px",
                                  height: "70px",

                                  background: "var(--blue-light)",
                                  borderRadius: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginTop: "5px",
                                  position: "relative",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faClose}
                                  style={{
                                    color: "var(--blue-dark)",
                                    cursor: "pointer",
                                    height: "15px",
                                    width: "15px",
                                    padding: "5px",
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                    transform: "translate(50%, -50%)",
                                  }}
                                  onClick={() => {
                                    let temp = [...this.state.why];
                                    temp[index].icon = { url: "", obj: "" };
                                    this.setState({ why: temp });
                                  }}
                                />
                                <img
                                  src={value.icon.url}
                                  alt=""
                                  style={{
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            ) : (
                              <div
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  position: "relative",
                                  background: "var(--blue-light)",
                                  borderRadius: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginTop: "5px",
                                }}
                              >
                                <input
                                  type="file"
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    opacity: 0,
                                  }}
                                  accept="image/*"
                                  onChange={(e) => {
                                    let temp = [...this.state.why];
                                    temp[index].icon = {
                                      url: URL.createObjectURL(
                                        e.target.files[0]
                                      ),
                                      obj: e.target.files[0],
                                    };
                                    this.setState({ why: temp });
                                  }}
                                />
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  style={{ color: "var(--blue-dark)" }}
                                />
                              </div>
                            )}
                          </div>
                          {value.icon.url && (
                            <>
                              <InputField
                                type="text"
                                isLabel={true}
                                lable="Icon Caption"
                                value={value.iconCaption}
                                onChange={(e) => {
                                  let temp = [...this.state.why];
                                  temp[index].iconCaption = e.target.value;
                                  this.setState({ why: temp });
                                }}
                              />
                              <InputField
                                type="text"
                                isLabel={true}
                                lable="Icon Alt"
                                value={value.iconAlt}
                                onChange={(e) => {
                                  let temp = [...this.state.why];
                                  temp[index].iconAlt = e.target.value;
                                  this.setState({ why: temp });
                                }}
                              />
                            </>
                          )}
                          <InputField
                            type="text"
                            isLabel={true}
                            lable="Title"
                            value={value.title}
                            onChange={(e) => {
                              let temp = [...this.state.why];
                              temp[index].title = e.target.value;
                              this.setState({ why: temp });
                            }}
                          />
                          <InputField
                            type="textarea"
                            isLabel={true}
                            lable="Description"
                            value={value.description}
                            onChange={(e) => {
                              let temp = [...this.state.why];
                              temp[index].description = e.target.value;
                              this.setState({ why: temp });
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="card grid">
                <h3>Meta Data</h3>
                <InputField
                  isLabel={true}
                  lable="Slug"
                  type="text"
                  value={this.state.slug}
                  onChange={(e) => this.setState({ slug: e.target.value })}
                />
                <InputField
                  isLabel={true}
                  lable="Meta Title"
                  type="text"
                  value={this.state.metaTitle}
                  onChange={(e) => this.setState({ metaTitle: e.target.value })}
                />
                <InputField
                  isLabel={true}
                  lable="Meta Description"
                  type="textarea"
                  value={this.state.metaDescription}
                  onChange={(e) =>
                    this.setState({ metaDescription: e.target.value })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Canonical Url"
                  type="textarea"
                  value={this.state.metaCanonicalUrl}
                  onChange={(e) =>
                    this.setState({ metaCanonicalUrl: e.target.value })
                  }
                />
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(AddUpdateIndustries);
